import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame", "stream"]

  connect() {
    if (this.hasStreamTarget) {
      this.observe()
    }
  }

  disconnect() {
    this.observer?.disconnect()
  }

  observe() {
    this.observer = new MutationObserver(() => {
      if (this.streamTarget.hasAttribute("connected")) {
        this.loadFrame()
      }
    })

    this.observer.observe(this.streamTarget, { attributeFilter: ["connected"] })
  }

  loadFrame() {
    if (this.hasFrameTarget && this.frameTarget.dataset.src) {
      this.frameTarget.src = this.frameTarget.dataset.src
    }
  }
}
